import Cookie from 'js-cookie';
import { ENVIRONMENT_COOKIE_NAME } from '@tools/getDataEnvironment';
import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

/**
 * Resolves a passed data environment (Ex. 'environment=S637') with our service's default environment
 */
const resolveEnvironment = (environment?: string) => {
  return environment || Cookie.get(ENVIRONMENT_COOKIE_NAME) || publicRuntimeConfig.ENVIRONMENT_NAME;
};
export default resolveEnvironment;
